import React, { useEffect, useState } from "react"
import { Card, CardBody, Form, Label, Modal, Table } from "reactstrap"
import { fetchNodeData, FetchNodePostData, FetchPostData } from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import Select from "react-select"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"


const IntroducerCommission = () => {
    const [data, setData] = useState([])
    const [allData, setAllData] = useState([])
    const [loading, setLoading] = useState(false)
    const [proposalValue, setProposalValue] = useState('')
    const [introducerDetail, setIntroducerDetail] = useState({})
    const [introducerId, setIntroducerId] = useState([])
    const [addCommision, setAddCommission] = useState(false)
    const [commType, setCommType] = useState([])
    const [commission, setCommission] = useState("")
    const [commissionAmounts, setCommissionAmount] = useState("")
    const [details, setDetails] = useState({})
    const commissionOption = [
        { label: "Percentage %", value: "percentage" },
        { label: "Flat", value: "flat" },
    ]
    const toggleLoading = loading => {
        setLoading(loading)
    }
    const token = secureLocalStorage.getItem('auth_token')
    const onGetData = async () => {
        const res = await fetchNodeData(toggleLoading, `commissionApproval`, token);
        if (res?.status) {
            setIntroducerDetail(res?.data?.introducer)
            const leads = res?.data?.leads ?? [];
            const projects = res?.data?.projects ?? [];
            const mergedData = [
                ...leads.map(obj => ({ ...obj, type: 1 })),
                ...projects.map(obj => ({ ...obj, type: 2 })),
            ];
            setData(mergedData)
            setAllData(mergedData)
        }
    }
    useEffect(() => {
        onGetData()
    }, [])

    const onSearchNotification = (e) => {
        const searchTerm = e.target.value.toLowerCase();

        const filteredData = allData.filter(obj => {
            // Parse person name if type is 1
            let personName = "-";
            if (obj?.type == 1) {
                try {
                    const personal = JSON.parse(obj.person_details) || [];
                    if (Array.isArray(personal) && personal.length > 0) {
                        personName = personal[0]?.person_name?.toLowerCase() || "-";
                    }
                } catch (err) {
                    console.error("Invalid JSON in person_details", err);
                }
            } else {
                personName = obj?.customer_name?.toLowerCase() || "-";
            }

            // Propose name from company or project
            const projectOrCompany = obj?.type == 1 ? obj?.company : obj?.project_name;

            return (
                obj?.id?.toString().includes(searchTerm) ||
                obj?.introducer_details?.introducer_name?.toLowerCase()?.includes(searchTerm) ||
                projectOrCompany?.toLowerCase()?.includes(searchTerm) ||
                personName.includes(searchTerm) ||
                obj?.introducer_details?.commission_structure?.toLowerCase()?.includes(searchTerm) ||
                obj?.introducer_details?.commission?.toString().includes(searchTerm)
            );
        });

        setData(filteredData);
    };

    const onApproveCommission = async (e) => {
        e.preventDefault();
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to approve commission?",
            showCancelButton: true,
            confirmButtonText: 'Yes, approve',
            cancelButtonText: 'No, cancel',
        }).then(async (okay) => {
            if (okay?.isConfirmed) {
                const formEntires = {
                    type: details?.type,
                    id: details?.id,
                    introducer: introducerId?.value,
                    commission: commissionAmounts,
                    commission_structure: commType?.value
                }
                const res = await FetchNodePostData(toggleLoading, "commissionApproval", token, formEntires);
                if (res?.data?.status) {
                    Swal.fire({
                        icon: "success",
                        title: "Commission approved successfully",
                    })
                    setAddCommission(false)
                    onGetData(introducerId)
                }
            }
        })

    }
    return (
        <React.Fragment>
            {loading && <Loader />}
            <div>
                <Card>
                    <CardBody>
                        <div className=" d-flex justify-content-between">
                            <div className="d-flex gap-2 col-md-6 align-items-center">
                                <p className="text-purple fs-5 mb-0 fw-bold col-md-4">Introducer Commission</p>
                                <div className="d-flex gap-3">
                                    <div className="d-flex justify-content-center align-items-center gap-1"><span className="bg-primary border-black" style={{ padding: "6px" }}></span>- <span>Leads</span></div>
                                    <div className="d-flex justify-content-center align-items-center gap-1"><span className="bg-success border-black" style={{ padding: "6px" }}></span>- <span>Projects</span></div>
                                </div>
                            </div>
                            <div>
                                <input id="search-bar-0" type="text" className="border-radius form-control rounded h-100"
                                    placeholder="Search..." onChange={(e) => onSearchNotification(e)} />
                            </div>
                        </div>
                        <div className="text-danger mb-4">* Once a lead is converted into a project, the project will be displayed instead of the lead. The lead will no longer appear separately</div>
                        <div className="responsive-table mb-4" >
                            <Table className="table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th className=" header">Id</th>
                                        <th className=" header col-md-2">Introducer</th>
                                        <th className="header ">Lead / Project </th>
                                        <th className="header col-2">Customer</th>
                                        <th className="header col-2">Commission Structure</th>
                                        <th className="header col-1">Commission</th>
                                        <th className="header col-1 text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.map((obj, i) => {
                                        let PersonName
                                        if (obj?.type == 1) {
                                            const personal = JSON.parse(obj.person_details) || {}
                                            if (personal != null && personal?.length == 0) {
                                                PersonName = "-"
                                            } else if (personal != null) {
                                                PersonName = personal[0]?.person_name || "-"
                                            }
                                        } else {
                                            PersonName = obj?.customer_name
                                        }
                                        const commission = obj?.introducer_details?.commission_structure
                                        const value = obj?.introducer_details?.commission

                                        const proposeAmount = obj?.type == 2 ? obj?.contract_value : 0;
                                        let commissionAmount;
                                        if (commission == 'percentage') {
                                            commissionAmount = (value / 100) * proposeAmount
                                        } else {
                                            commissionAmount = value
                                        }
                                        return (
                                            <tr key={i}>
                                                <td>{obj?.id}</td>
                                                <td>
                                                    <div>
                                                        <i className={` ${obj?.type == 1 ? "bx bx-tone me-2 text-primary fw-bold" : 'bx bx-task text-success me-2 fw-bold'} `}></i>

                                                        {obj?.introducer_details?.introducer_name}
                                                    </div>
                                                </td>
                                                <td className="">
                                                    {obj?.type == 1 ? obj?.company : obj?.project_name}
                                                </td>
                                                <td>
                                                    {PersonName}
                                                </td>
                                                <td className="text-capitalize">
                                                    {commission} - {value}
                                                </td>
                                                <td>
                                                    {commissionAmount}
                                                </td>
                                                <td className="text-center">
                                                    <a title="edit" className="btn btn-sm btn-outline-secondary me-1" onClick={() => {
                                                        setAddCommission(true)
                                                        setDetails(obj)
                                                        setCommType(commissionOption?.find((obj) => obj?.value == commission))
                                                        setCommission(value)
                                                        setCommissionAmount(commissionAmount)
                                                        setProposalValue(proposeAmount)
                                                    }}>
                                                        <i className="fas fa-pen "></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                            {data?.length == 0 ? (
                                <p className="text-center text-purple fw-bold mt-3">
                                    🎉 There is no Commission Approval Pending for Introducers 🚀
                                </p>
                            ) : null}
                        </div>
                    </CardBody>
                </Card>
            </div>

            <Modal
                isOpen={addCommision}
                size="md"
                className=""
                centered
            >
                <div className="modal-header">
                    <h5 className="modal-title mt-0">Introducer Commission</h5>
                    <button
                        type="button"
                        onClick={() => {
                            setAddCommission(false)
                        }}
                        className="btn-modal-close"
                    >
                        <span aria-hidden="true" className="btn-modal-span">
                            ×
                        </span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="pb-2 mb-3">
                        <p className="text-capitalize">
                            <i className="mdi mdi-chevron-right text-primary me-1"></i>
                            <span className="text-purple fw-bold ">{details?.type == 1 ? "Lead Name" : 'Project Name'} </span> : {details?.type == 1 ? details?.company : details?.project_name}
                        </p>
                        {proposalValue != 0 ? (
                            <p className="text-capitalize">
                                <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                <span className="text-purple fw-bold ">Contract Amount </span> : {proposalValue}
                            </p>
                        ) : null}
                    </div>
                    <Form className="row" onSubmit={onApproveCommission}>
                        <div className="col-md-7">
                            <label htmlFor="">Select Commission Type</label>
                            <Select
                                name="select discount"
                                placeholder="Select"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                options={commissionOption}
                                value={commType}
                                onChange={e => {
                                    setCommission("")
                                    setCommType(e)
                                }}
                            />
                        </div>
                        <div className="mb-3 col-md-5">
                            <Label htmlFor="formrow-firstname-Input">Commission</Label>
                            <input
                                type="text"
                                className="form-control"
                                id="formrow-firstname-Input"
                                placeholder="Commission"
                                value={commission}
                                onChange={e => {
                                    setCommission(e.target.value)
                                    setCommissionAmount((e.target.value / 100) * proposalValue)
                                }}
                                required
                            />
                        </div>
                        {details?.type == 2 ? (
                            <div className="mb-3 col-md-5">
                                <Label htmlFor="formrow-firstname-Input">Commission Amount</Label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-Input"
                                    placeholder="Commission"
                                    value={commissionAmounts}
                                    disabled
                                />
                            </div>
                        ) : null}
                        <div className="text-danger">*  Contract Amount & Calculated Commission Amount is only visible in Project Commission, not in Lead, as it's not entered during lead creation.</div>
                        <div className=" text-end mt-3">
                            <button type="submit" className="border-radius btn btn-purple">
                                Confirm Commission
                            </button>
                        </div>
                    </Form>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default IntroducerCommission
